import { useMemo } from 'react';
import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';

/**
 * This is a replacement function for the makeStyles that we removed that was deprecated in mui 5
 * https://dev.to/atonchev/material-ui-5-the-easiest-way-to-migrate-from-makestyles-to-emotion-1i9l
 */
const useClasses = (stylesElement: any) => {
   const theme = useTheme();
   return useMemo(() => {
      const rawClasses = typeof stylesElement === 'function'
         ? stylesElement(theme)
         : stylesElement;
      const prepared: Record<string, any> = {};

      Object.entries(rawClasses).forEach(([key, value = {}]) => {
         prepared[key] = css(value as any)
      });

      return prepared;
   }, [stylesElement, theme]);
};

export default useClasses;
